import React from 'react';
import classNames from 'classnames';

import { GUIDE_CARD_TOKEN } from '../../constants/onboardingCopy';

import css from './ChatGuideCard.module.css';

const variantClass = variant => {
  switch (variant) {
    case 'success':
      return css.variantSuccess;
    case 'warning':
      return css.variantWarning;
    case 'action':
      return css.variantAction;
    default:
      return css.variantInfo;
  }
};

/**
 * Just-In-Time contextual guide rendered as a system message in the chat feed.
 *
 * @param {Object} props
 * @param {Object} props.guide - Resolved guide from getChatGuideForState()
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 */
const ChatGuideCard = props => {
  const { guide, className, rootClassName } = props;

  if (!guide?.title) {
    return null;
  }

  const token = guide.token || guide.layoutToken;
  const classes = classNames(
    css.root,
    variantClass(guide.variant),
    rootClassName,
    className
  );

  return (
    <div
      className={classes}
      role="note"
      data-guide-token={token}
      data-layout-token={GUIDE_CARD_TOKEN}
      data-onboarding-id={guide.id}
    >
      <p className={css.label}>Guide</p>
      <p className={css.title}>{guide.title}</p>
      <p className={css.body}>{guide.body}</p>
    </div>
  );
};

export default ChatGuideCard;
